export default __webpack_public_path__ + "static/media/medline.1642a101.svg";